import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NecCacheable } from './cacheable';
import { NecLocalStorageService } from './../localStorage/local-storage.service';


@Injectable()
export class NecCacheService {
  /**
   * localStorageé»è®¤æå¤§å­å¨å®¹é
   */
  readonly localStorageMaxSize = 10 * 1024 * 1024;
  /**
   * localStorageå½åå·²ç»ä¿å­çæ°æ®å¤§å°
   */
  localStorageCurrentSize = 0;
  /**
   * ä½¿ç¨Mapä½ä¸ºåå­çç¼å­
   */
  map = new Map<string, NecCacheable<any>>();
  /**
   * è®¡ç®md5å¼çå·¥å·çå·¥å·åº
   */
  jssha = require('jssha');

  constructor(
    private localStorageService: NecLocalStorageService
  ) {
    for (let keyIndex = 0, length = localStorage.length; keyIndex < length; keyIndex++) {
      this.localStorageCurrentSize += localStorage[localStorage.key(keyIndex)].length * 2;
    }
  }

  get(key: string, cacheLevel?: string) {
    cacheLevel = cacheLevel || 'MEMORY';
    switch (cacheLevel) {
      case 'LOCALSTORAGE':
        return this.localStorageService.get(key);
      case 'MEMORY':
      default:
        return this.map.get(key);
    }
  }

  put(key: string, value: NecCacheable<any>, cacheLevel?: string) {
    cacheLevel = cacheLevel || 'MEMORY';
    switch (cacheLevel) {
      case 'LOCALSTORAGE':
        let valueLength = JSON.stringify(value).length * 2;
        if (this.localStorageCurrentSize + valueLength > this.localStorageMaxSize) {
          if (this.perpareLocalStorageSpace(valueLength)) {
            this.localStorageService.set(key, value);
          }
        }
        else {
          this.localStorageService.set(key, value);
        }
        break;
      case 'MEMORY':
      default:
        return this.map.set(key, value);
    }
  }

  del(key: string, cacheLevel?: string) {
    cacheLevel = cacheLevel || 'MEMORY';
    switch (cacheLevel) {
      case 'LOCALSTORAGE':
        this.localStorageService.del(key);
        break;
      case 'MEMORY':
      default:
        this.map.delete(key);
    }
  }

  expire(key: string, cacheLevel?: string): boolean {
    const cacheable = this.get(key, cacheLevel);
    if (cacheable && cacheable.expireTime > new Date().getTime()) {
      return false;
    }
    else {
      return true;
    }
  }

  md5(request: HttpRequest<any>): string {
    let shaObj = new this.jssha('SHA-1', 'TEXT');
    shaObj.setHMACKey('512ks', 'TEXT');
    shaObj.update(request.method);
    shaObj.update(request.url);
    shaObj.update(JSON.stringify(request.params));
    shaObj.update(JSON.stringify(request.body));
    return shaObj.getHMAC('HEX');
  }


  private perpareLocalStorageSpace(size: number) {
    let rmItemIndex = -1, rmItemSize = this.localStorageMaxSize;
    for (let keyIndex = 0, length = localStorage.length; keyIndex < length; keyIndex++) {
      let keySize = localStorage[localStorage.key(keyIndex)].length * 2;
      if (keySize > size && keySize < rmItemSize) {
        rmItemIndex = keyIndex;
        rmItemSize = keySize;
      }
    }

    if (rmItemIndex > 0) {
      localStorage.removeItem(localStorage.key(rmItemIndex));
      return true;
    }
    else {
      return false;
    }
  }
}
